
export default {
  name: "FreeSizerBlock",
  props: {
    data: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    contentHtml() {
      return (
        this.data?.mixedTranslation?.content?.content ||
        this.data?.mixedTranslation?.content ||
        this.data?.content ||
        ""
      );
    },
  },
  methods: {
    contentClick(e) {
      const link = e.target.closest("a")?.href;
      if (link) {
        const url = new URL(link);
        if (window.location.host === url.host && !url.hash) {
          e.preventDefault();
          this.$router.push(this.localePath(url.pathname + url.search));
        }
      }
    },
  },
};
